import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useDeductibleScheduleStepPatientPaySchedules from "./hooks/useDeductibleScheduleStepPatientPaySchedules";

const DeductibleScheduleStepPatientPaySchedules = () => {
  const deductibleScheduleStepPatientPaySchedulesData =
    useDeductibleScheduleStepPatientPaySchedules();

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={deductibleScheduleStepPatientPaySchedulesData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {deductibleScheduleStepPatientPaySchedulesData.screen_title} -{" "}
          <span className="heading-cod">
            {deductibleScheduleStepPatientPaySchedulesData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={deductibleScheduleStepPatientPaySchedulesData.formFields}
        dropdownValues={
          deductibleScheduleStepPatientPaySchedulesData.dropdownValues
        }
        paramsData={deductibleScheduleStepPatientPaySchedulesData.paramsData}
        updataParamData={
          deductibleScheduleStepPatientPaySchedulesData.updateParamData
        }
      />
      <ButtonsSection
        ctaButtons={deductibleScheduleStepPatientPaySchedulesData.ctaButtons}
      />
      <DisplayTable
        data={deductibleScheduleStepPatientPaySchedulesData.data}
        parmKey={deductibleScheduleStepPatientPaySchedulesData.parmKey}
        menuOptions={deductibleScheduleStepPatientPaySchedulesData.menuOptions}
        tableHeaders={deductibleScheduleStepPatientPaySchedulesData.columnDef}
        setRowData={deductibleScheduleStepPatientPaySchedulesData.setRowData}
        selectedPriceSchedules={
          deductibleScheduleStepPatientPaySchedulesData.selectedRows
        }
        setSelectedPriceSchedules={
          deductibleScheduleStepPatientPaySchedulesData.setSelectedRows
        }
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={deductibleScheduleStepPatientPaySchedulesData.first}
          rows={deductibleScheduleStepPatientPaySchedulesData.rows}
          totalRecords={
            deductibleScheduleStepPatientPaySchedulesData.totalRecords
          }
          currentPage={
            deductibleScheduleStepPatientPaySchedulesData.currentPage
          }
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={
            deductibleScheduleStepPatientPaySchedulesData.onPageChange
          }
        />
      </div>
      {deductibleScheduleStepPatientPaySchedulesData.isInactiveConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={
            deductibleScheduleStepPatientPaySchedulesData.isInactiveConfirmationModalOpen
          }
          onRequestClose={
            deductibleScheduleStepPatientPaySchedulesData.closeInactiveConfirmationModal
          }
          onBack={
            deductibleScheduleStepPatientPaySchedulesData.closeInactiveConfirmationModal
          }
          onSave={
            deductibleScheduleStepPatientPaySchedulesData.inactivateRecord
          }
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={
            deductibleScheduleStepPatientPaySchedulesData.setInactiveSelectedOption
          }
        />
      )}
    </div>
  );
};

export default DeductibleScheduleStepPatientPaySchedules;
